import { ImageUpload } from '@/components/FileUpload/ImageUpload';
import { FormManagementProps } from '@/type/form.types';
import { ErrorResponse } from '@/utils/axios.http';
import { UseMutateFunction } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { FieldValues } from 'react-hook-form';
import { R2_PUBLIC_DOMAIN } from '@/utils/constant.utils';

interface GroupCheckPointBackgrounImageProps<
  TSchema extends FieldValues,
> extends FormManagementProps<TSchema> {
  checkPointBackgroundImageField: string;
  mutateUploadImage?: UseMutateFunction<
    AxiosResponse<unknown, unknown>,
    ErrorResponse,
    FormData,
    unknown
  >;
}

export const GroupCheckPointBackgrounImage = <TSchema extends FieldValues>({
  t,
  checkPointBackgroundImageField,
  data,
  submitDisabled,
  mutateUploadImage,
}: GroupCheckPointBackgrounImageProps<TSchema>) => {
  const minimumImageWidth = '1280';
  const minimumImageHeight = '800';

  return (
    <div>
      <div className="font-medium">{t('common:backgroundImage')} (PNG) :</div>
      <div className="mt-1">
        <div className="text-sm text-gray-600">
          {t('common:minimumAllowedDimensions')} : {minimumImageWidth}px x{' '}
          {minimumImageHeight}px
        </div>
        <div className="text-sm text-gray-600">
          {t('common:sizeMaxMb', { size: 2 })}
        </div>
      </div>
      <div className="mt-5">
        <ImageUpload
          t={t}
          chooseAnotherImgContainerClassName="mt-6"
          allowedFormats={['png']}
          minimumImageWidth={minimumImageWidth}
          minimumImageHeight={minimumImageHeight}
          disabledChooseAnotherImgButton={submitDisabled}
          mutateUploadImage={mutateUploadImage}
          initialImage={
            data?.groupCustomImage?.[checkPointBackgroundImageField] &&
            `${R2_PUBLIC_DOMAIN}/images/group/${data?.id}/${data?.groupCustomImage?.[checkPointBackgroundImageField]}`
          }
        />
      </div>
    </div>
  );
};
